import FormTextField from 'Components/FormTextField'
import NumberRangeInputs from 'Components/NumberRangeInputs'
import StyledLabel from 'Components/StyledLabel'
import TranslationInput from 'Components/TranslationInput'
import type { ParameterGroupParameter } from 'Services/ProductManagement/Features/Parameter/types'
import type { ParameterTranslation } from 'Store'
import { CUSTOMER_GROUP_CATEGORY, IS_WALTTI_SERVICE_ENVIRONMENT } from 'Util/constants'
import { Box, Typography } from '@mui/material'
import type { default as React } from 'react'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export function ParameterFormFields({
  parameterGroupParameter,
  handleSetDetails,
  isEdit
}: Readonly<{
  parameterGroupParameter: ParameterGroupParameter
  handleSetDetails: (
    value: string | number | null | ParameterTranslation[],
    name: keyof ParameterGroupParameter
  ) => void
  isEdit: boolean
}>) {
  const { parameterGroupCategory } = useParams()

  const handleTextInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    handleSetDetails(value, name as keyof ParameterGroupParameter)
  }
  const handleSetTranslations = (updatedTranslations: ParameterTranslation[]) => {
    handleSetDetails(updatedTranslations, 'translations')
  }

  const handleNumberInputChange = (minValue: number | null, maxValue: number | null) => {
    handleSetDetails(minValue, 'minimum')
    handleSetDetails(maxValue, 'maximum')
  }

  return (
    <>
      <Box sx={{ display: 'flex', columnGap: 2 }}>
        <FormTextField
          size="medium"
          required
          disabled={isEdit}
          label={t`Identifier`}
          name={'parameter_id'}
          value={parameterGroupParameter?.parameter_id}
          onChange={handleTextInputChange}
        />
        <FormTextField
          size="medium"
          required
          label={t`Name`}
          name={'parameter_name'}
          value={parameterGroupParameter?.parameter_name}
          onChange={handleTextInputChange}
        />
      </Box>
      {IS_WALTTI_SERVICE_ENVIRONMENT && parameterGroupCategory === CUSTOMER_GROUP_CATEGORY && (
        <Box>
          <StyledLabel>{t`Age range`}</StyledLabel>
          <NumberRangeInputs
            minValueLabel={t`Minimum age`}
            maxValueLabel={t`Maximum age`}
            minValueName="minimum"
            maxValueName="maximum"
            minValue={parameterGroupParameter.minimum}
            maxValue={parameterGroupParameter.maximum}
            handleNumberInputChange={handleNumberInputChange}
          />
        </Box>
      )}
      <Box>
        <StyledLabel>{t`Translations`}</StyledLabel>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography fontSize={18} sx={{ mr: 1, minWidth: 30 }} color="text.secondary">
            FI
          </Typography>
          <TranslationInput
            translations={parameterGroupParameter.translations}
            field="value"
            label={t`Name`}
            locale={'fi'}
            setTranslations={handleSetTranslations}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography fontSize={18} sx={{ mr: 1, minWidth: 30 }} color="text.secondary">
            SV
          </Typography>
          <TranslationInput
            sx={{ my: 0 }}
            translations={parameterGroupParameter.translations}
            field="value"
            label={t`Name`}
            locale={'sv'}
            setTranslations={handleSetTranslations}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography fontSize={18} sx={{ mr: 1, minWidth: 30 }} color="text.secondary">
            EN
          </Typography>
          <TranslationInput
            translations={parameterGroupParameter.translations}
            field="value"
            label={t`Name`}
            locale={'en'}
            setTranslations={handleSetTranslations}
          />
        </Box>
      </Box>
    </>
  )
}
